import React, { useEffect, useRef } from 'react';
import CBHorizontalCarousel from '@cb/apricot/CBHorizontalCarousel';
import cn from 'classnames';
export const carouselVariants = ['light', 'dark', 'menu', 'menu-condensed'];
export const HorizontalCarousel = ({ carouselId, children, ariaLabel, variant, bgClass, arrowClass, scrollDistance = 150, selectedClass, itemClass, className, }) => {
    const carouselClassName = cn(`cb-horizontal-carousel`, variant && `cb-horizontal-carousel-${variant}`, className);
    const ref = useRef(null);
    useEffect(() => {
        CBHorizontalCarousel({
            elem: ref.current,
            markup: false,
            scrollDistance,
            selectedClass,
            itemClass,
        });
    }, []);
    return (React.createElement("div", { id: carouselId, role: "region", "aria-label": ariaLabel, className: carouselClassName, "data-cbtrack-comp": "apricot-react:horizontal-carousel", ref: ref },
        React.createElement("div", { className: "cb-horizontal-nav cb-horizontal-nav-left" },
            React.createElement("a", { "aria-label": "scroll content to left", href: "/#", tabIndex: -1, "aria-disabled": "true", className: cn(bgClass && bgClass, arrowClass && arrowClass) },
                React.createElement("span", { className: cn(`cb-icon`, !variant && `cb-left`, variant && `cb-carousel-backward`), "aria-hidden": "true" }))),
        React.createElement("div", { className: "cb-horizontal-carousel-nav" },
            React.createElement("div", { className: "cb-horizontal-carousel-content" }, children)),
        React.createElement("div", { className: "cb-horizontal-nav cb-horizontal-nav-right" },
            React.createElement("a", { "aria-label": "scroll content to right", href: "/#", tabIndex: -1, "aria-disabled": "true", className: cn(bgClass, arrowClass) },
                React.createElement("span", { className: cn(`cb-icon`, !variant && `cb-right`, variant && `cb-carousel-forward`), "aria-hidden": "true" })))));
};
//# sourceMappingURL=horizontal-carousel.js.map